// src/api/arrecadacao.js
import axios from 'axios';

/* ---------- limpeza de "linha" (compat c/ legado) ---------- */
const cleanLinha = (raw) => {
  if (!raw) return '';
  return String(raw)
    .replace(/^\uFEFF/, '')
    .trim()
    .replace(/^(?:Resposta|RESP\.?)[\s-]*/i, '')
    .replace(/\s+/g, '');
};

const deepCleanLinhas = (node) => {
  if (!node || typeof node !== 'object') return;
  if (Array.isArray(node)) { node.forEach(deepCleanLinhas); return; }
  for (const k of Object.keys(node)) {
    const v = node[k];
    const kl = k.toLowerCase();
    if (
      kl === 'linha' || kl === 'linhanumero' || kl === 'numerolinha' ||
      kl === 'dslinha' || kl === 'linhanome' || kl === 'numero_linha' ||
      kl === 'trajetonome' || kl === 'numerolinha'
    ) {
      if (typeof v === 'string') node[k] = cleanLinha(v);
    }
    if (v && typeof v === 'object') deepCleanLinhas(v);
  }
};

/* ---------- bases ---------- */
const API_BASE = process.env.REACT_APP_API_BASE ?? '';
const API_KEY  = process.env.REACT_APP_API_KEY;
console.log('🔍 arrecadacao.js - API_BASE (env):', process.env.REACT_APP_API_BASE);
console.log('🔍 arrecadacao.js - API_BASE (final):', API_BASE);

/* Cliente para as rotas antigas de arrecadação */
const api = axios.create({ baseURL: `${API_BASE}/api/arrecadacao` });

api.interceptors.request.use((config) => {
  try { deepCleanLinhas(config.data); } catch {}
  if (API_KEY) config.headers['Authorization'] = API_KEY;
  return config;
});
api.interceptors.response.use((res) => {
  try { deepCleanLinhas(res.data); } catch {}
  return res;
});

/* Cliente para o cache MySQL (novas rotas) */
const clientCache = axios.create({ baseURL: `${API_BASE}/api/cache` });

clientCache.interceptors.request.use((config) => {
  if (API_KEY) config.headers['Authorization'] = API_KEY;
  return config;
});

/* ---------- funções exportadas (compat + novas) ---------- */

// (LEGADO) Continua igual — usa a rota antiga e devolve array
export async function postRelatorio(payload) {
  const { data } = await api.post('/relatorio', payload);
  return data?.rows || [];
}

// (LEGADO)
export async function getKpis(params) {
  const { data } = await api.get('/kpis', { params });
  return data?.kpis;
}

// (LEGADO)
export async function exportCsv(params, mode = 'panel') {
  const resp = await api.get('/export/csv', { params: { ...params, mode }, responseType: 'blob' });
  return resp.data;
}

// (LEGADO)
export async function exportXlsx(params) {
  const resp = await api.get('/export/xlsx', { params, responseType: 'blob' });
  return resp.data;
}

/* ---------- NOVA: agregado mensal direto do MySQL ---------- */
/**
 * GET /api/cache/arrec/mensal?garage=3&ano=2025&tipo=vt
 * retorna: [{ ym:'2025-01', total: 12345.67, tipos: { vt:..., pagante:..., ... } }, ...]
 */
export async function getMensalCache({ garage, ano, tipo = '' }) {
  const { data } = await clientCache.get('/arrec/mensal', {
    params: { garage, ano, tipo }
  });
  return Array.isArray(data) ? data : [];
}